import classNames from "classnames";
import { format } from "date-fns";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function CalendarToolbar(toolbar) {
    const goToBack = () => {
        toolbar.onNavigate("PREV");
    };

    const goToNext = () => {
        toolbar.onNavigate("NEXT");
    };

    const formatDate = () => {
        const date = toolbar.date;
        switch (toolbar.view) {
            case "day":
                return format(date, "EEEE, d MMMM yyyy");
            case "week": {
                const start = format(date, "d MMMM yyyy");
                const end = format(
                    new Date(date.getTime() + 6 * 24 * 60 * 60 * 1000),
                    "d MMMM yyyy"
                );
                return `${start} - ${end}`;
            }
            default:
                return format(date, "MMMM yyyy");
        }
    };

    return (
        <div className="flex justify-between items-center xl:mb-2 2xl:mb-2 3xl:mb-4">
            <div className="flex items-center xl:gap-4 2xl:gap-4 3xl:gap-8">
                <div className="flex gap-2 xl:gap-1 2xl:gap-2 3xl:gap-3">
                    <button
                        onClick={goToBack}
                        className="p-2 xl:p-1 2xl:p-1 3xl:p-2 border rounded-md hover:bg-gray-50 text-black"
                    >
                        <ChevronLeft className="w-4 h-4 xl:w-3 xl:h-3 2xl:w-3 2xl:h-3 3xl:w-4 3xl:h-4" />
                    </button>
                    <button
                        onClick={goToNext}
                        className="p-2 xl:p-1 2xl:p-1 3xl:p-2 border rounded-md hover:bg-gray-50 text-black"
                    >
                        <ChevronRight className="w-4 h-4 xl:w-3 xl:h-3 2xl:w- 2xl:h-3 3xl:w-4 3xl:h-4" />
                    </button>
                </div>
                <span className="text-md xl:text-xs 2xl:text-sm 3xl:text-base font-medium text-primary border border-gray-300 rounded-md px-2 py-1">
                    {formatDate()}
                </span>
            </div>
            <div className="inline-flex rounded-lg bg-gray-100 p-1">
                <button
                    onClick={() => toolbar.onView("day")}
                    className={classNames(
                        "px-4 py-1 text-xm xl:text-xs 2xl:text-sm 3xl:text-base font-medium rounded-md transition-colors",
                        toolbar.view === "day"
                            ? "bg-white shadow-sm text-black border border-gray-300"
                            : "text-gray-600 hover:text-gray-900"
                    )}
                >
                    Day
                </button>
                <button
                    onClick={() => toolbar.onView("week")}
                    className={classNames(
                        "px-4 py-1 text-xs xl:text-xs 2xl:text-sm 3xl:text-base font-medium rounded-md transition-colors",
                        toolbar.view === "week"
                            ? "bg-white shadow-sm text-black border border-gray-300"
                            : "text-gray-600 hover:text-gray-900"
                    )}
                >
                    Week
                </button>
                <button
                    onClick={() => toolbar.onView("month")}
                    className={classNames(
                        "px-4 py-1 text-sm xl:text-xs 2xl:text-sm 3xl:text-base font-medium rounded-md transition-colors",
                        toolbar.view === "month"
                            ? "bg-white shadow-sm text-black border border-gray-300"
                            : "text-gray-600 hover:text-gray-900"
                    )}
                >
                    Month
                </button>
            </div>
        </div>
    );
}
